<template>
    <div class="row px-1 px-md-0 pt-2" id="mentions">
        <div class="col-12 pb-2"
             v-for="(legalMention, index) in legalMentions" :key="index">
            <!-- bouton collapse -->
            <button
                type="button"
                class="ob1-link-arrow text-start legal-mention-toggle"
                data-bs-toggle="collapse"
                aria-expanded="true"
                :id="'mention' + index"
                :data-bs-target="'#collapsed-text' + index"
                :aria-controls="'collapsed-text' + index"
            >
                {{ legalMention.title }}
            </button>

            <!-- contenu collapsible -->
            <div class="collapse show font-size-resp-12" :id="'collapsed-text' + index"
                 :aria-labelledby="'mention' + index">
                <div v-safe-html="legalMention.text"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "LegalMentions",
    props: {
        legalMentions: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
</style>
